import { useState } from 'react';
import type { ReportingFilters } from '../../../utils/types/reporting/reporting_types';
import { REPORTING_DEPARTMENTS, REPORTING_JOB_TITLES } from '../constants';
import { createDefaultFilters } from '../functions';

export interface IUseReportingFilters {
  filters: ReportingFilters;
  setFilters: React.Dispatch<React.SetStateAction<ReportingFilters>>;
  departments: string[];
  jobTitles: string[];
}

/** Manages filter criteria for all reporting views. */
export const useReportingFilters = (): IUseReportingFilters => {
  const [filters, setFilters] = useState<ReportingFilters>(createDefaultFilters);

  return {
    filters,
    setFilters,
    departments: REPORTING_DEPARTMENTS,
    jobTitles: REPORTING_JOB_TITLES,
  };
};
